var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.5834H10.0084M6.83341 18.3334H13.1667C14.1002 18.3334 14.5669 18.3334 14.9234 18.1518C15.237 17.992 15.492 17.737 15.6518 17.4234C15.8334 17.0669 15.8334 16.6002 15.8334 15.6667V4.33341C15.8334 3.39999 15.8334 2.93328 15.6518 2.57676C15.492 2.26316 15.237 2.00819 14.9234 1.8484C14.5669 1.66675 14.1002 1.66675 13.1667 1.66675H6.83341C5.89999 1.66675 5.43328 1.66675 5.07676 1.8484C4.76316 2.00819 4.50819 2.26316 4.3484 2.57676C4.16675 2.93328 4.16675 3.39999 4.16675 4.33342V15.6667C4.16675 16.6002 4.16675 17.0669 4.3484 17.4234C4.50819 17.737 4.76316 17.992 5.07676 18.1518C5.43328 18.3334 5.89999 18.3334 6.83341 18.3334ZM10.4167 14.5834C10.4167 14.8135 10.2302 15.0001 10.0001 15.0001C9.76996 15.0001 9.58341 14.8135 9.58341 14.5834C9.58341 14.3533 9.76996 14.1667 10.0001 14.1667C10.2302 14.1667 10.4167 14.3533 10.4167 14.5834Z",
    stroke: "#666666",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone01);
export default __webpack_public_path__ + "static/media/phone-01.d243d3a900b1ced65ea6cd375ae29d58.svg";
export { ForwardRef as ReactComponent };